export default __webpack_public_path__ + "static/media/docker_monitor.7be2976e.md";